<script>
import { createGtm, DebugLogPlugin } from '@injoi-utils/vue2-gtm';

export default {
  commonDataLayer: createGtm({
    // decide will event being sent to GTM container (default: true)
    isEnabled: true,
    // GTM container ID
    gtmId: 'GTM-PC5SK8',
    // Optional, specific the dataLayer name
    // Hint: you should always do this to prevent conflict with other departments
    dataLayerName: 'dataLayer',
    plugins: [
      // DebugLogPlugin(),
    ],
  }),
};
</script>

<style scoped>

</style>